import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-opticaltransceivertesting-appnote',
  templateUrl: '../../templates/Template-nested-sidebar-lead.html',
  styleUrls: ['./nested-sidebar-opticaltransceivertesting-appnote.component.scss']
})
export class NestedSidebarOpticaltransceivertestingAppnoteComponent implements OnInit {

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() { }

  pdf = {
    pdfTitle: '400G Advanced Optical<br>Transceiver Testing App Note',
    pdfimg: './assets/images/sidebar/400G_Advanced_Transceiver_Testing_FINAL_Page_1.webp',
    url: 'opticaltransceivertesting',
    opt: 'BUTTON.DOWNLOAD',
    width: '1700',
    height: '2200'
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
  }

}
